import { requests, setAPIRoot } from '@yola/yousersjs';
import traqing from '@yola/traqing.js';
import analytics from './analytics';
import user from './user';
import constants from './constants';
import appendIframe from './helpers/append-iframe';

const initRoadMap = async (config) => {
  const {
    common: {
      domain,
      'public-api-gateway': gateways,
      'yola-editor': editor,
      product_board: { embedding_url: embeddingUrl },
    },
    'yola-public-roadmap': yolaPublicRoadmap,
  } = config;

  const isWl = window.location.hostname === yolaPublicRoadmap.wl_domain;
  const segmentIOKey = yolaPublicRoadmap.segmentio.write_key;
  const apiUrl = isWl ? gateways.wl_url : gateways.url;
  setAPIRoot(apiUrl);

  try {
    const { user_id: userId, token } = await requests.getProductBoardToken();
    const { segment } = traqing;
    const { verifiers } = analytics;
    segment.init(segmentIOKey, apiUrl);
    const frontEndTrackingEnabled = verifiers.isAnalyticsEnabled();
    segment.identify(userId, { frontEndTrackingEnabled }, () => {
      user.updateUserPreference(
        user.constants.preferences.FRONTEND_TRACKING_ENABLED,
        frontEndTrackingEnabled
      );
    });

    appendIframe(embeddingUrl, token);

    setTimeout(() => {
      segment.track(constants.events.APP_OPENED, { appName: constants.common.APP_NAME });
    }, 1000);
  } catch (error) {
    // eslint-disable-next-line
    console.error(error);

    if (error.response && error.response.status === 401) {
      appendIframe(embeddingUrl);
    } else {
      window.location.href = isWl ? editor.wl_url : editor.url;
    }
  }
};

export default initRoadMap;
